import {
  GET_SALESTARGET,
  GET_SALESTARGET_SUCCESS,
  GET_SALESTARGET_FAIL,
  DELETE_SALESTARGET,
  DELETE_SALESTARGET_SUCCESS,
  DELETE_SALESTARGET_FAIL,
  UPDATE_SALESTARGET,
  UPDATE_SALESTARGET_SUCCESS,
  UPDATE_SALESTARGET_FAIL,
  ADD_NEW_SALESTARGET,
  ADD_SALESTARGET_SUCCESS,
  ADD_SALESTARGET_FAIL,
  SALESTARGET_LOADING,
  SALESTARGET_RESET,
} from "./actionType";

export const resetSalesTargetState = (actionType) => ({
  type: SALESTARGET_RESET,
  payload: { actionType },
});

export const getSalesTargetSuccess = (actionType, data) => ({
  type: GET_SALESTARGET_SUCCESS,
  payload: { actionType, data },
});

export const getSalesTargetFail = (actionType, error) => ({
  type: GET_SALESTARGET_FAIL,
  payload: { actionType, error },
});

export const getSalesTarget = data => ({
  type: GET_SALESTARGET,
  payload: data,
});

export const getSalesTargetLoading = () => ({
  type: SALESTARGET_LOADING
});

export const deleteSalesTarget = data => ({
  type: DELETE_SALESTARGET,
  payload: data,
});

export const deleteSalesTargetSuccess = data => ({
  type: DELETE_SALESTARGET_SUCCESS,
  payload: data,
});

export const deleteSalesTargetFail = error => ({
  type: DELETE_SALESTARGET_FAIL,
  payload: error,
});

export const updateSalesTarget = data => ({
  type: UPDATE_SALESTARGET,
  payload: data,
});

export const updateSalesTargetFail = error => ({
  type: UPDATE_SALESTARGET_FAIL,
  payload: error,
});

export const updateSalesTargetSuccess = data => ({
  type: UPDATE_SALESTARGET_SUCCESS,
  payload: data,
});

export const addNewSalesTarget = data => ({
  type: ADD_NEW_SALESTARGET,
  payload: data,
});

export const addSalesTargetSuccess = data => ({
  type: ADD_SALESTARGET_SUCCESS,
  payload: data,
});

export const addSalesTargetFail = error => ({
  type: ADD_SALESTARGET_FAIL,
  payload: error,
});